import { createFileRoute } from "@tanstack/react-router";

import { OrganizationOverviewPage } from "src/pages/OrganizationOverviewPage";

export const Route = createFileRoute("/_auth/_coach/orgs/$slug/")({
  component: OrganizationOverviewPage,
  ssr: true,
});
